import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import SessionLockModal from '@/components/modals/SessionLockModal.vue';

import PinCodeProcessor from '@/helpers/hashPin'

import Storage from "@/helpers/storage";

import PageLoader from "@/components/loaders/PageLoader.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPinModal',
  setup(__props) {

const storage = new Storage();

const showNewPin = ref<boolean>(false);
const loading = ref<boolean>(false);
const newPinCode = ref<string>('');

const hasPinCode = (): void => {
    if (PinCodeProcessor.noPinCode()) {
        loading.value = true
        newPinCode.value = getRandomInt(100000, 999999).toString();

        PinCodeProcessor.setPin(newPinCode.value).then(() => {
            showNewPin.value = true;
            loading.value = false
        }).catch((error: any) => { console.log(error) });
    }
}

const getRandomInt = (min: number, max: number): number => {
    // find diff
    const difference = max - min;

    // generate random number 
    let rand = Math.random();

    // multiply with difference 
    rand = Math.floor(rand * difference);

    // add with min value 
    rand = rand + min;

    return rand;
}

const toClipboard = async () => {
    await navigator.clipboard.writeText(newPinCode.value).then(() => {
        showNewPin.value = false
    });
};

onMounted(() => {
    if (!storage.get('isSessionLock')) {
        hasPinCode();
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNewPin.value)
      ? (_openBlock(), _createBlock(SessionLockModal, {
          key: 0,
          show: showNewPin.value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (showNewPin.value = false)),
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (toClipboard())),
          title: "Account Pin",
          content: "This is an auto-generated PIN",
          "action-text": "Copy",
          "cancel-text": "Close",
          pinCode: newPinCode.value,
          validate: false,
          hasPinCode: "",
          whiteBg: ""
        }, null, 8, ["show", "pinCode"]))
      : _createCommentVNode("", true),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
  ], 64))
}
}

})